import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse
} from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { finalize, tap } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { StateService } from './state.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class HttpLoadingInterceptor implements HttpInterceptor {
  private ongoingRequests : number = 0;

  constructor(private stateService: StateService) {}
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.ongoingRequests++;
    this.stateService.loading = true;
    return next.handle(req).pipe(
      finalize(
        () => { this.ongoingRequests--; this.stateService.loading = this.ongoingRequests > 0; }
      ),
      tap(
        event => {},
        // Operation failed; error is an HttpErrorResponse
        error => { this.stateService.errors.push(error); console.log(error); }
      ));
  }
}

export const HttpLoadingInterceptorProvider = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpLoadingInterceptor, multi: true },
]